import { Injectable, NgZone } from '@angular/core';
import { AppComponent } from 'app/app.component';
import { LicensingService } from './licensing.service';
import { Subscription, interval } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class InactivityService {
  activityEvents = ['mousemove', 'click'];
  timeoutId: any;
  sessionValidationSubject: Subscription;
  isActive: boolean = true;

  constructor(
    private ngZone: NgZone,
    public app: AppComponent,
    private licensingService: LicensingService
  ) {    
    localStorage.removeItem('sessionResult');
    if(localStorage.getItem('sessionId')) this.validateSession();    
    this.startMonitoring();
    this.resetTimeout();
  }

  logout(): void {
    this.stopMonitoring();
    this.terminateSession();
    sessionStorage.clear();
    localStorage.removeItem('qx_userId');
    localStorage.removeItem('qx_username');
    window.location.href = '/signin';
  }

  //#region Inactivity Validation
  startMonitoring(): void {
    this.activityEvents.forEach(event => {
      window.addEventListener(event, this.resetTimeout.bind(this));
    });
  }

  stopMonitoring(): void {
    this.activityEvents.forEach(event => {
      window.removeEventListener(event, this.resetTimeout.bind(this));
    });    
  }

  resetTimeout(): void {    
    if(!this.isActive) {      
      this.isActive = true;
      this.startSessionValidation();
      this.validateSession(); 
    }

    this.ngZone.runOutsideAngular(() => {
      this.timeoutId = window.setTimeout(() => {
        this.ngZone.run(() => this.stopSessionValidation());
      }, 125000);
    });
  }    
  //#endregion
  
  //#region Session Validation
  startSessionValidation(): void {      
    this.sessionValidationSubject = interval(120000).subscribe(() => {
      this.validateSession();
    });
  }
  
  stopSessionValidation(): void {
    this.isActive = false;
    if (this.sessionValidationSubject) {
      this.sessionValidationSubject.unsubscribe();      
    }
  }
  
  validateSession(): void {        
    if(!localStorage.getItem('sessionId') || localStorage.getItem('sessionId') == undefined) {
      this.logout();
      return;
    }

    let formData = this.app.buildForm(['sessionId'], [localStorage.getItem('sessionId')])
    this.licensingService.validateSession(formData).subscribe({
      next: (data: { result: boolean, message: string }) => {          
        if (!data.result) {
          this.stopSessionValidation();
          localStorage.setItem('sessionResult', `Result: ${data.result}. Message: ${data.message}`);                 
          this.logout();
        }
      }, error: (errorLog) => { console.log(errorLog); }
    })
  }

  terminateSession(): void {    
    if(!localStorage.getItem('sessionId') || localStorage.getItem('sessionId') == undefined) return;

    let sessionId = Number(localStorage.getItem('sessionId'));
    this.stopSessionValidation();
    if (sessionId > 0) {
      localStorage.removeItem('sessionId');
      let formData = this.app.buildForm(['sessionId'], [sessionId.toString()]);
      this.licensingService.terminateSession(formData).subscribe({
        error: (errorLog) => { console.log(errorLog); }
      })
    }
  }
  //#endregion
}
